import { useCallback, useState } from 'react';
import { produce, Draft } from 'immer';

// 如果set传入回调函数则走immer模式 直接set值则走useState模式
// 定义 useImmer Hook
function useImmer<T>(
  initialState: T | (() => T)
): [T, (updater: T | ((draft: Draft<T>) => void)) => void] {
  // 使用 useState 初始化状态
  const [state, setState] = useState<T>(initialState);

  // 使用 useCallback 封装更新函数
  const updateState = useCallback((updater: T | ((draft: Draft<T>) => void)) => {
    if (typeof updater === 'function') {
      // 如果 updater 是函数，使用 Immer 的 produce 处理
      setState(prevState => produce(prevState, updater as (draft: Draft<T>) => void));
    } else {
      // 如果 updater 是普通值，直接设置为新状态
      setState(updater);
    }
  }, []);

  // 返回状态和更新函数
  return [state, updateState];
}

export default useImmer;
